import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

import Header from './Components/Header';
import Footer from './Components/Footer';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState('');

    const mapStyle = {
        border:'0',
        width: '100%',
        height: '350px'
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setStatus('');
      
        try {
          const serviceId = 'service_wgu86ha';
          const templateId = 'template_42xq6jg';
          const publicKey = 'MIo4VqrDsvFPjfiuL';
      
          const templateParams = {
            from_name: formData.name,
            from_email: formData.email,
            subject: formData.subject,
            message: formData.message,
          };
      
          console.log('Sending email with params:', templateParams);
          const result = await emailjs.send(serviceId, templateId, templateParams, publicKey);
          console.log('Email sent successfully:', result);
      
          setStatus('success');
          setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
          console.error('Error sending email:', error);
          setStatus('error');
        } finally {
          setIsLoading(false);
        }
    };
    return(
        <div>
            <Header/> 
            <main id="main">
                <section id="breadcrumbs" className="breadcrumbs">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <h2>Contact</h2>
                            <ol>
                                <li><a href="/index">Home</a></li>
                                <li>Contact</li>
                            </ol>
                        </div>
                    </div>
                </section>
                <div className="map-section">
                    <iframe style={mapStyle} src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12097.433213460943!2d-74.0062269!3d40.7101282!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb89d1fe6bc499443!2sDowntown+Conference+Center!5e0!3m2!1smk!2sbg!4v1539943755621" frameBorder="0" allowFullScreen></iframe>
                </div>
                <section id="contact" className="contact">
                    <div className="container">
                        <div className="row justify-content-center" data-aos="fade-up">
                            <div className="col-lg-10">
                                <div className="info-wrap">
                                    <div className="row justify-content-between">

                                        <div className="col-lg-3 info mt-4 mt-lg-0">
                                            <a href='mailto:saady.a@kpa-structure.team'><i className="bi bi-envelope"></i></a>
                                            <h4>Email:</h4>
                                            <p>saady.a@kpa-structure.team</p>
                                        </div>

                                        <div className="col-lg-3 info mt-4 mt-lg-0">
                                        <a href='tel:+1-555-555-1212'><i className="bi bi-phone" /></a>
                                        <h4>Call:</h4>
                                        <p>+1 (718) 814-8229</p>
                                        </div>

                                        <div className="col-lg-3 info mt-4 mt-lg-0">
                                        <a target='_blank' href='https://wa.me/13026411780'><i className="bi bi-whatsapp"></i></a>
                                        <h4>Whatsapp:</h4>
                                        <p>+1 302 641 1780</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-5 justify-content-center" data-aos="fade-up">
                            <div className="col-lg-10">
                                <form onSubmit={handleSubmit} role="form" className="php-email-form">
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                        <input 
                                            type="text" 
                                            name="name" 
                                            className="form-control" 
                                            id="name" 
                                            placeholder="Your Name" 
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        </div>
                                        <div className="col-md-6 form-group mt-3 mt-md-0">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            name="email" 
                                            id="email" 
                                            placeholder="Your Email" 
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="subject" 
                                            id="subject" 
                                            placeholder="Subject" 
                                            value={formData.subject}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <textarea 
                                            className="form-control" 
                                            name="message" 
                                            rows="5" 
                                            placeholder="Message" 
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="my-3">
                                        {isLoading && <div className="loading">Sending message...</div>}
                                        {status === 'error' && <div className="error-message">Failed to send message. Please try again.</div>}
                                        {status === 'success' && <div className="sent-message">Your message has been sent. Thank you!</div>}
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" disabled={isLoading}>
                                            {isLoading ? 'Sending...' : 'Send Message'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer/>
        </div>
    )
};

export default ContactUs;